module.exports = __webpack_public_path__ + "static/umbo-7c4369fc952e92174ff307337f3a9e0f.jpg";